import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';


@Injectable({
    providedIn: 'root'
})
export class LevelsService { 
    url='levels';
    constructor(private http:HttpClient) {}

    getAll(page:any,count:any,name:any){
        return this.http.get<any>(`${environment.apiUrl}/${this.url}?filter=${name}&page=${page}&count=${count}`);
    }
    all(){
        return this.http.get<any>(`${environment.apiUrl}/${this.url}`);
    }
  
    get(id:any){
        return this.http.get<any>(`${environment.apiUrl}/${this.url}/${id}`);
    }

    add(duty:any){
        return this.http.post<any>(`${environment.apiUrl}/${this.url}`,duty);
    }

    update(id:any,duty:any){
        return this.http.put<any>(`${environment.apiUrl}/${this.url}/${id}`,duty);
    }

    delete(id:any){
        return this.http.delete<any>(`${environment.apiUrl}/${this.url}/${id}`);
    }
}